<div class="text-center card p-2 mt-2"  *ngIf="prompt && !loading_answer_options">
<table class="table" >
  <tbody>
    <tr>
        <td colspan="2">{{prompt.label}}). {{prompt.questionText}}</td>
    </tr>
    <tr>
        <td class="text-end">Answer Given:</td>
        <td class="text-start" [innerHTML]="prompt.answerGiven['display']"></td>
    </tr>
    <tr>
        <td class="text-end">Correct Answer:</td>
        <td class="text-start" [innerHTML]="prompt.correctAnswer['display']"></td>
    </tr>
    <tr>
        <td class="text-end">Result:</td>
        <td class="text-start">
        <span *ngIf="prompt.is_correct">
            Passed (<i class="fa fa-check text-success"></i>)
        </span>
        <span *ngIf="!prompt.is_correct">
            Failed (<i class="fa fa-close text-danger"></i>)
        </span>
        </td>
    </tr>
  </tbody>
    </table>
    <app-revise-answer-prompt-description [prompt]="prompt"></app-revise-answer-prompt-description>
</div>
